import { NoticeExtractorScheduledEventResponseDto } from 'app/API';
import { DataRows } from '../DataRows';

type TProps = {
  events?: NoticeExtractorScheduledEventResponseDto[];
};

export function EventsCard({ events = [] }: TProps) {
  return (
    <section className="col-span-full min-w-0 rounded-[10px] border border-border bg-surface p-3.5">
      <h3 className="mb-2.5 text-sm font-bold leading-5 text-foreground">Scheduled events</h3>
      {events.length ? (
        <div className="grid gap-2.5">
          {events.map((event, index) => (
            <div
              className="rounded-lg border border-border bg-surface-muted p-2.5"
              key={`${event.event_type ?? 'event'}-${index}`}
            >
              <DataRows
                rows={[
                  { label: 'Event type', value: event.event_type },
                  { label: 'Date', value: event.date },
                  { label: 'Time', value: event.time },
                  { label: 'Location', value: event.location },
                  { label: 'Participants', value: event.participants },
                  { label: 'Service provider', value: event.service_provider },
                ]}
              />
            </div>
          ))}
        </div>
      ) : (
        <span className="text-xs leading-[18px] text-foreground-muted">No scheduled events found</span>
      )}
    </section>
  );
}
